import {
    Alert, Avatar, Button, Card, Col, Divider, Image, Input, Modal, Row, Select, Spin, Table, Tag, Timeline, Typography
} from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { apiCall } from '../../API/RestApi';
import { modalError } from '../../Component/Modal/ModalLayout';
import { useSelector } from 'react-redux';
import Search from 'antd/es/input/Search';
import moment from 'moment';
import { dateFormat, dateFormatDate } from '../../Utils/formatDate';
import heic2any from "heic2any";

const { Option } = Select;
function ApprovalLeavePaid() {
    const token = useSelector((state) => state.user.token);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [statusFilter, setStatusFilter] = useState('');
    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50', '100'],
        },
    });
    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState('');
    const [detailData, setDetailData] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [convertedImages, setConvertedImages] = useState([]);
    const [imageLoading, setImageLoading] = useState(false);
    const [bulkModalVisible, setBulkModalVisible] = useState(false);
    const [bulkStatus, setBulkStatus] = useState('');
    const [bulkReason, setBulkReason] = useState('');
    const [bulkLoading, setBulkLoading] = useState(false);

    const [targetId, setTargetId] = useState(null);
    const [actionStatus, setActionStatus] = useState('');
    const [actionReason, setActionReason] = useState('');

    useEffect(() => {
        const convertHeicImages = async () => {
            if (!detailData?.leave_paid_image) return;

            setImageLoading(true); // Mulai loading

            const results = await Promise.all(
                detailData.leave_paid_image.map(async (img) => {
                    try {
                        const url = img.image;

                        if (url?.toLowerCase().endsWith(".heic")) {
                            const response = await fetch(url, { mode: "cors" });
                            const blob = await response.blob();

                            const converted = await heic2any({
                                blob,
                                toType: "image/jpeg",
                                quality: 0.9,
                            });

                            return {
                                ...img,
                                convertedUrl: URL.createObjectURL(converted),
                            };
                        } else {
                            return { ...img, convertedUrl: url };
                        }
                    } catch (error) {
                        console.error("Gagal konversi HEIC:", error);
                        return { ...img, convertedUrl: img.image };
                    }
                })
            );

            setConvertedImages(results);
            setImageLoading(false); // Selesai loading
        };

        convertHeicImages();
    }, [detailData]);

    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            render: (_, __, index) => (page.pagination.current - 1) * page.pagination.pageSize + index + 1,
        },
        {
            title: 'User Code',
            dataIndex: 'users_code',
            render: (_, record) => record.users?.users_code || '-',
        },
        {
            title: 'Name',
            dataIndex: 'name',
            render: (_, record) => record.users?.name || '-',
        },
        {
            title: 'Description',
            dataIndex: 'desc',
        },
        {
            title: 'Start Date',
            dataIndex: 'date_start',
            render: (_, record) => moment(record.date_start).format('DD-MM-YYYY'),
        },
        {
            title: 'End Date',
            dataIndex: 'date_end',
            render: (_, record) => moment(record.date_end).format('DD-MM-YYYY'),
        },
        {
            title: 'Time Off Type',
            dataIndex: 'leave_type',
            render: (_, record) => {
                if (record.leave_type !== null) {
                    return record.leave_type.name
                } else {
                    return '-';
                }
            }
        },
        {
            title: 'Created At',
            dataIndex: 'created_at',
            render: (_, record) =>
                record.created_at ? dateFormat(record.created_at) : '-',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            render: (_, record) => {
                const colorMap = {
                    Approved: 'green',
                    Rejected: 'red',
                    Process: 'yellow',
                };
                return <Tag color={colorMap[record.status] || 'gray'}>{record.status}</Tag>;
            },
        },
        {
            title: 'Action',
            dataIndex: 'action',
            render: (_, record) => {
                return (
                    <Button type="default" style={{ marginRight: 10 }} onClick={() => showDetailModal(record)}>
                        <b>Detail</b>
                    </Button>
                );
            },
        },
    ];

    function checkApproval(item) {
        const items = item.leave_paid_approval;
        return items.length === 1 && items[0].status_approval_id === 2;
    }

    const getApi = (method, url, type) => {
        setLoading(true);
        apiCall({
            method,
            url,
            data: {
                headers: {
                    Authorization: 'Bearer ' + token,
                },
            },
        })
            .then((res) => {
                if (res.status === 'success') {
                    if (type === 'detail') {
                        setDetailData(res.data);
                        setIsModalVisible(true);
                    } else {
                        setData(res.data.data);
                        setPage({
                            ...page,
                            pagination: {
                                ...page.pagination,
                                total: res.data.total_data,
                            },
                        });
                    }
                }
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
                console.error(e.message);
            });
    };

    const postApi = async (method, url, values) => {
        setLoading(true);
        setIsAlert(false);
        await apiCall({
            method,
            url,
            data: {
                data: values,
                headers: {
                    Authorization: 'Bearer ' + token,
                },
            },
        })
            .then((res) => {
                setLoading(false);
                if (res.status === 'success') {
                    setIsAlert(true);
                    setTextAlert(res.message);
                    getApi('GET', '/leavepaid?isDelegation=true&search=' + search + '&status=' + statusFilter + '&page=1', 'leave_paid');
                    setSelectedRowKeys([]);
                } else {
                    modalError(res.message);
                }
            })
            .catch((e) => {
                setLoading(false);
                console.error(e.message);
            });
    };

    const showDetailModal = (data) => {
        getApi('GET', '/leavepaid/' + data.leave_paid_id, 'detail');
    };

    const handleTableChange = (pagination) => {
        setPage({
            pagination: {
                ...page.pagination,
                current: pagination.current,
                pageSize: pagination.pageSize,
                total: page.pagination.total,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '50', '100'],
            },
        });
    };

    const searchData = (value) => {
        setSearch(value);
        setPage({
            pagination: {
                ...page.pagination,
                current: 1,
            },
        });
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: (newSelectedKeys) => {
            setSelectedRowKeys(newSelectedKeys);
        },
        getCheckboxProps: (record) => ({
            disabled: record.status !== 'Process' || !checkApproval(record),
        }),
    };

    useEffect(() => {
        const statusQuery = statusFilter ? `&status=${statusFilter}` : '';
        const searchQuery = search ? `&search=${search}` : '';
        getApi(
            'GET',
            `/leavepaid?isDelegation=true${searchQuery}${statusQuery}&page=${page.pagination.current}&limit=${page.pagination.pageSize}`,
            'leave_paid'
        );
    }, [
        page.pagination.current,
        page.pagination.pageSize,
        search,
        statusFilter,
        isAlert
    ]);

    const handleFilterChange = (value) => {
        setStatusFilter(value || '');
        setPage({
            pagination: {
                ...page.pagination,
                current: 1,
            },
        });
    };

    return (
        <div>
            <Helmet>
                <title>Time Off Approval Data</title>
            </Helmet>
            {isAlert && (
                <Alert
                    message={textAlert}
                    type="success"
                    banner
                    closable
                    afterClose={() => setIsAlert(false)}
                />
            )}
            <h3>Time Off Approval Data</h3>
            <Row gutter={16} style={{ marginBottom: 16 }}>
                <Col span={8}>
                    <Search placeholder="Search" allowClear enterButton onSearch={searchData} />
                </Col>
                <Col span={8}>
                    <Select
                        placeholder="Filter by status"
                        allowClear
                        style={{ width: 160 }}
                        onChange={handleFilterChange}
                    >
                        <Option value="Process">Process</Option>
                        <Option value="Approved">Approved</Option>
                        <Option value="Rejected">Rejected</Option>
                    </Select>
                </Col>
                <Col span={8} style={{ textAlign: 'right' }}>
                    <Button
                        onClick={() => setBulkModalVisible(true)}
                        disabled={selectedRowKeys.length === 0}
                    >
                        Bulk Action ({selectedRowKeys.length})
                    </Button>
                </Col>
            </Row>

            <Table
                rowKey="leave_paid_id"
                rowSelection={rowSelection}
                size="middle"
                columns={columns}
                dataSource={data}
                pagination={page.pagination}
                loading={loading}
                onChange={handleTableChange}
            />

            <Modal
                title="Time Off Detail"
                open={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={null}
                width={900}
            >
                {loading ? (
                    <Spin tip="Loading..." />
                ) : (
                    detailData && (
                        <Card>
                            <Typography.Title level={5}>Time Off Information</Typography.Title>
                            <Row gutter={[16, 16]}>
                                <Col span={12}>
                                    <Typography.Text strong>Employee Name:</Typography.Text>
                                    <Typography.Paragraph>{detailData.users.name}</Typography.Paragraph>
                                </Col>
                                <Col span={12}>
                                    <Typography.Text strong>Time Off Type:</Typography.Text>
                                    <Typography.Paragraph>{detailData.leave_type.name}</Typography.Paragraph>
                                </Col>
                                <Col span={12}>
                                    <Typography.Text strong>Submission Date:</Typography.Text>
                                    <Typography.Paragraph>{new Date(detailData.date).toLocaleDateString()}</Typography.Paragraph>
                                </Col>
                                <Col span={12}>
                                    <Typography.Text strong>Status:</Typography.Text>
                                    <Typography.Paragraph>{detailData.status}</Typography.Paragraph>
                                </Col>
                                <Col span={24}>
                                    <Typography.Text strong>Description:</Typography.Text>
                                    <Typography.Paragraph>{detailData.desc || '-'}</Typography.Paragraph>
                                </Col>
                                <Col span={12}>
                                    <Typography.Text strong>Start Date:</Typography.Text>
                                    <Typography.Paragraph>{dateFormatDate(detailData.date_start)}</Typography.Paragraph>
                                </Col>
                                <Col span={12}>
                                    <Typography.Text strong>End Date:</Typography.Text>
                                    <Typography.Paragraph>{dateFormatDate(detailData.date_end)}</Typography.Paragraph>
                                </Col>
                            </Row>

                            <Divider />
                            <Typography.Title level={5}>Attachments</Typography.Title>

                            {imageLoading ? (
                                <div style={{ textAlign: "center", padding: "40px 0" }}>
                                    <Spin tip="Loading attachments..." />
                                </div>
                            ) : (
                                <Row gutter={[16, 16]}>
                                    {convertedImages?.length > 0 ? (
                                        convertedImages.map((img) => (
                                            <Col key={img.leave_paid_image_id} span={6}>
                                                <Image
                                                    src={img.convertedUrl}
                                                    width={200}
                                                    height={200}
                                                    style={{
                                                        objectFit: "contain",
                                                        borderRadius: "10px",
                                                        border: "1px solid #F2F2F2",
                                                    }}
                                                />
                                            </Col>
                                        ))
                                    ) : (
                                        <Col span={24}>
                                            <Typography.Text>No attachments</Typography.Text>
                                        </Col>
                                    )}
                                </Row>
                            )}


                            <Divider />
                            <Typography.Title level={5}>Approval History</Typography.Title>
                            <Timeline mode="left" style={{ marginTop: 20 }}>
                                {detailData.leave_paid_approval?.map((approval) => (
                                    <Timeline.Item
                                        key={approval.leave_paid_approval_id}
                                        color={
                                            approval.status_approval_id === 2
                                                ? "green"
                                                : approval.status_approval_id === 3
                                                    ? "red"
                                                    : "yellow"
                                        }
                                    >
                                        <Row gutter={8} align="middle">
                                            <Col>
                                                <Avatar src={approval.user?.image} />
                                            </Col>
                                            <Col>
                                                <Typography.Text strong>{approval.user?.name || "-"}</Typography.Text><br />
                                                <Tag
                                                    color={
                                                        approval.status_approval_id === 2
                                                            ? "green"
                                                            : approval.status_approval_id === 3
                                                                ? "red"
                                                                : "yellow"
                                                    }
                                                >
                                                    {approval.status_approval?.status}
                                                </Tag><br />
                                                <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                                    {dateFormat(approval.created_at) || "-"}
                                                </Typography.Text><br />
                                                {approval.reason && (
                                                    <Typography.Text italic style={{ fontSize: 12 }}>
                                                        Reason: {approval.reason}
                                                    </Typography.Text>
                                                )}
                                            </Col>
                                        </Row>
                                    </Timeline.Item>
                                ))}
                            </Timeline>
                            <div style={{ marginTop: 20, textAlign: 'right' }}>
                                <Button
                                    type="primary"
                                    onClick={() => {
                                        setTargetId(detailData.leave_paid_id);
                                        setActionStatus('');
                                        setActionReason('');
                                        setBulkModalVisible(true);
                                    }}
                                >
                                    Change Status
                                </Button>
                            </div>


                        </Card>
                    )
                )}
            </Modal>


            <Modal
                title="Approval Action"
                open={bulkModalVisible}
                onCancel={() => setBulkModalVisible(false)}
                onOk={async () => {
                    if (!bulkStatus && !actionStatus) {
                        modalError('Please select approval status');
                        return;
                    }

                    const statusVal = bulkStatus || actionStatus;
                    const reasonVal = bulkReason || actionReason;

                    setBulkLoading(true);

                    try {
                        if (targetId) {
                            // Single Approval
                            await postApi('PUT', `/leavepaidapprovalfinal/${targetId}`, {
                                status_approval_id: statusVal === 'Approved' ? 2 : 3,
                                reason: reasonVal || '',
                            });
                        } else {
                            // Bulk Approval
                            await postApi('PUT', '/leavepaidapprovalfinalbulk', {
                                ids: selectedRowKeys,
                                status_approval_id: statusVal === 'Approved' ? 2 : 3,
                                reason: reasonVal || '',
                            });
                        }
                    } finally {
                        setBulkLoading(false);
                        setBulkModalVisible(false);
                        setIsModalVisible(false)
                        setTargetId(null);
                        setBulkStatus('');
                        setActionStatus('');
                        setBulkReason('');
                        setActionReason('');
                    }
                }}
                okText={bulkLoading ? 'Processing...' : 'Submit'}
                okButtonProps={{ loading: bulkLoading }}
            >
                <p>
                    {targetId
                        ? 'Set approval for this request'
                        : `${selectedRowKeys.length} item(s) selected`}
                </p>
                <Select
                    placeholder="Select Status"
                    style={{ width: '100%', marginBottom: 12 }}
                    onChange={(val) => {
                        setBulkStatus(val);
                        setActionStatus(val);
                    }}
                    value={bulkStatus || actionStatus}
                >
                    <Option value="Approved">Approved</Option>
                    <Option value="Rejected">Rejected</Option>
                </Select>
                <Input.TextArea
                    placeholder="Reason (optional)"
                    rows={3}
                    value={bulkReason || actionReason}
                    onChange={(e) => {
                        setBulkReason(e.target.value);
                        setActionReason(e.target.value);
                    }}
                />
            </Modal>

        </div>
    );
}

export default ApprovalLeavePaid;
